import apiFetch from '../apiFetch'

export default function () {
  return apiFetch({endPoint: `Recta`, method: 'GET', body: null})
}
